<template>
    <div>
        <el-row class="layout-page-heading">
            <el-col :span="24">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>系统用户</el-breadcrumb-item>
                    <el-breadcrumb-item>角色管理</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <div>
            <el-button type="primary" @click="add"><i class="fa fa-plus"></i>添加角色
            </el-button>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="id" label="角色编号"></el-table-column>
                <el-table-column prop="jurisdictionName" label="角色名"></el-table-column>
                <el-table-column prop="creatTime" label="创建时间"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button style="margin-right: 10px;margin-bottom: 5px" @click="edit(scope.$index, scope.row)" type="primary" size="small">编辑</el-button>
                            <!-- <el-button style="margin-right: 10px;margin-bottom: 5px"
                                @click="del(scope.$index, scope.row)" type="danger" size="small">删除</el-button> -->
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增角色弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form label-width="80px" label-position="right" class="edit-form">
                <el-form-item label="角色名">
                    <el-input v-model="jurisdictionName" placeholder="角色名"></el-input>
                </el-form-item>
                <el-form-item label="权限">
                    <el-tree :data="permissions" show-checkbox node-key="functionNo" :check-strictly="true" ref="tree" :props="{children:'functionDtoList',label:'functionName'}">
                    </el-tree>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="closs()">取 消</el-button>
                <el-button type="primary" @click="doAddgoods()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 编辑角色弹框 -->
        <el-dialog :visible.sync="editDialog" center class="dialogItem" :close-on-click-modal="false">
            <el-form label-width="80px" label-position="right" class="edit-form">
                <el-form-item label="角色名">
                    <el-input v-model="jurisdictionName" placeholder="角色名"></el-input>
                </el-form-item>
                <el-form-item label="权限">
                    <el-tree :data="permissions" show-checkbox node-key="functionNo" :check-strictly="true" ref="tree" :props="{children:'functionDtoList',label:'functionName'}">
                    </el-tree>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="editDialog=false">取 消</el-button>
                <el-button type="primary" @click="editSubmit()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "list",
    data() {
        return {
            tableData: [],
            filters: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                }
            },
            dialogFormVisible: false,
            editDialog: false,
            permissions: [],
            jurisdictionName: '',
            roleId: ''
        }
    },
    methods: {
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.filters)
                }, {
                        random: Math.random()
                    })
            })
        },
        edit(index, row) {
            this.editDialog = true
            this.roleId = row.id
            api.request("personnel/findByJurisdictionId", {
                id: row.id
            }, (res) => {
                let arr = (res.data.functionNo).split(',')
                this.$refs.tree.setCheckedKeys(arr)
                this.jurisdictionName = res.data.jurisdictionName
            }, (err) => { })
            this.init()
        },
        editSubmit() {
            var data = {
                functionNo: (this.$refs.tree.getCheckedKeys()).toString(),
                jurisdictionName: this.jurisdictionName,
                id: this.roleId
            }
            api.request("personnel/createJurisdiction", data, (res) => {
                _g.toast('success', '修改成功')
                this.editDialog = false
                this.query()
            }, (err) => { })
        },
        closs() {
            this.dialogFormVisible = false
        },
        query() {
            var querys = {
                page: this.filters.pagination.page,
                size: this.filters.pagination.limit,
            }
            api.requestQuiet("personnel/findJurisdictionPage", querys, (res) => {
                this.tableData = res.data.list
                this.filters.pagination.total = res.data.total
            }, (err) => { })
        },
        init() {
            api.request('personnel/findFunctionAll', {}, (res) => {
                this.permissions = res.data
            }, (err) => { })
            // api.request("personnel/findPersonnelAll", {}, (res) => {
            //     _g.toast('success', '修改成功')
            //     this.editDialog = false
            //     this.query()
            // })
        },
        doAddgoods() {
            var data = {
                functionNo: (this.$refs.tree.getCheckedKeys()).toString(),
                jurisdictionName: this.jurisdictionName
            }
            api.request("personnel/createJurisdiction", data, (res) => {
                _g.toast('success', '添加成功')
                this.dialogFormVisible = false
                this.query()
            }, (err) => { })
        },
        add() {
            this.dialogFormVisible = true
            this.functionNo = []
            this.jurisdictionName = ''
            this.init()
        },
        // 删除角色
        del() { },

    },
    created() {
        this.query()
    },
    watch: {
        '$route'(to, from) {
            this.query()
        }
    }
}
</script>

<style scoped>
</style>